import { AppData } from "../../AppDataProvider";

export type ReservedSpaceDeletedOptions = {
  appData: AppData;
};

export const reservedSpaceDeleted = (
  options: ReservedSpaceDeletedOptions,
): AppData => {
  const updatedBookingData = options.appData.bookingData;
  delete updatedBookingData.reservedSpaceId;
  delete updatedBookingData.startDate;
  delete updatedBookingData.selectedBookings;

  return {
    ...options.appData,
    bookingData: updatedBookingData,
  };
};
